module.exports = __webpack_public_path__ + "img/share-icon-audio-select.c4fd7534.svg";